export const LimitType = {
  TRANSACTION: 'TRANSACTION',
  DAILY: 'DAILY',
} as const

export type LimitType = (typeof LimitType)[keyof typeof LimitType]

export interface LimitQualifiers {
  accountId: string | null
  customerId: string | null
  walletId: string | null
  bankingPartner: string | null
  method: string
}

export interface Limit {
  ruleId?: string
  limitType: LimitType
  amount: number
  currency: string
  method: string
  qualifiers?: LimitQualifiers
  owner?: string
}

export interface LimitsPageable {
  pageNumber: number
  pageSize: number
}

export interface LimitsResponse {
  content: Limit[]
  totalElements: number
  totalPages: number
  pageable: LimitsPageable
  hasNext: boolean
}

export type UpdateLimitPayload = Omit<Limit, 'owner' | 'qualifiers' | 'currency'> & {
  method: string
}

export interface LimitsQueryParams {
  pageNumber?: number
  pageSize?: number
  accountId?: string
  customerId?: string
  walletId?: string
  paymentMethod?: string
  limitType?: LimitType
  currency?: string
}

export interface CreateLimitPayload {
  accountId: string
  customerId?: string
  method: string
  limitType: LimitType
  amount: number
  currency: string
}

export interface AddLimitFormFields {
  currency: string
  method: string
  limitType: string
  amount: string
}

export interface EditLimitFormFields {
  limitType: string
  amount: string
}

export const PaymentLimitSheetType = {
  ADD: 'add',
  EDIT: 'edit',
} as const

export type PaymentLimitSheetType =
  (typeof PaymentLimitSheetType)[keyof typeof PaymentLimitSheetType]

export interface PaymentLimitSheetProps {
  isOpen: boolean
  type: PaymentLimitSheetType
  limit?: Limit | null
  customerId?: string
  onClose: () => void
}

export interface GroupedLimit {
  method: string
  currency: string
  transactionLimit?: Limit
  dailyLimit?: Limit
}
